export enum TicketType {
    Paid = 0,
    Free = 1,
    Donation = 2
}